"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var validation_1 = require("../../util/resources/validation");
var date = tslib_1.__importStar(require("date-fns"));
exports.isValidStatus = function (value, instance, ValidationError) {
    if (!~BaseTransactionResource.STATUS_ALL.indexOf(String(value))) {
        throw new ValidationError('status', "The value \"" + value + "\" is not a valid status");
    }
};
var BaseTransactionResource = /** @class */ (function (_super) {
    tslib_1.__extends(BaseTransactionResource, _super);
    function BaseTransactionResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseTransactionResource.related = function () {
        return {
            batch: require('./batch').default,
            period: require('../system/period').default,
            export: require('./exports').default,
            ledger: require('./ledgeritem').default,
            files: require('../system/file').default,
        };
    };
    BaseTransactionResource.prototype.getLines = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var Ctor, LinesClass;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Ctor = this.getConstructor();
                        LinesClass = Ctor.LINE_CLASS;
                        if (!LinesClass) {
                            throw new Error("Property \"LINE_CLASS\" for " + this.toResourceName() + " instance is not defined");
                        }
                        return [4 /*yield*/, LinesClass.list({ query: { transaction__id: this.id } })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    BaseTransactionResource.prototype.inGL = function () {
        var Ctor = this.getConstructor();
        return Ctor.STATUS_IN_GL.includes(this.get('status'));
    };
    BaseTransactionResource.prototype.post = function () {
        if (this.inGL()) {
            throw new Error("Can't set transaction to POSTED if it's already in GL");
        }
        this.set('status', 'POSTED');
        return this.save();
    };
    BaseTransactionResource.prototype.void = function () {
        if (!this.inGL()) {
            throw new Error("Can't VOID transaction if it's not in GL");
        }
        this.set('status', 'VOIDED');
        return this.save();
    };
    BaseTransactionResource.prototype.open = function () {
        if (this.inGL()) {
            throw new Error("Can't set transaction OPEN if transaction is in GL");
        }
        this.set('status', 'OPEN');
        return this.save();
    };
    BaseTransactionResource.prototype.close = function () {
        if (this.get('status') !== 'POSTED') {
            throw new Error("Can't close transaction if status isn't POSTED");
        }
        this.set('status', 'CLOSED');
        return this.save();
    };
    BaseTransactionResource.STATUS_ALL = ['DRAFT', 'OPEN', 'AUDITED', 'POSTED', 'VOIDED', 'CLOSED'];
    BaseTransactionResource.STATUS_IN_GL = ['POSTED', 'VOIDED', 'CLOSED'];
    BaseTransactionResource.defaults = {
        status: 'OPEN',
        period: null,
        date: function () {
            return date.format(new Date(), 'yyyy-MM-dd');
        },
    };
    BaseTransactionResource.validation = validation_1.extendValidators(base_1.default, {
        number: validation_1.isRequired('number'),
        description: validation_1.isRequired('description'),
        batch: validation_1.isRequired('batch'),
        status: [validation_1.isRequired('status'), exports.isValidStatus],
        date: [validation_1.isRequired('date'), validation_1.isValidDate('date')]
    });
    return BaseTransactionResource;
}(base_1.default));
exports.BaseTransactionResource = BaseTransactionResource;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/index.js
// module id = ZEEs
// module chunks = 0